// Mock the map data
const mapData = [
  {
    name: 'Jawa Barat',
    id: 'JB',
    type: 'province',
    coordinate: {
      lat: -6.918100,
      lng: 107.619122
    },
    link: '/organization',
    total: 6,
    markerType: 'organization',
    noInteraction: true,
  },
  {
    name: 'Jawa Timur',
    id: 'JT',
    type: 'province',
    coordinate: {
      lat: -7.257537,
      lng: 112.751971,
    },
    total: 2,
    markerType: 'organization',
    noInteraction: true,
  }
]

export default mapData
